
      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12">
            <p-panel header="{{ 'LBL_SELECCIONARTERCERO' | translate}}">
              <fieldset>
                <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fSeleccionar" name="fSeleccionar">
                  <div class="grid form-group">
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label>* {{ 'LBL_TIPODOCUMENTO' | translate }}</label>
                        <p-dropdown disableTab  id="idTipoDocumento" name="nomTipoDocumento" [options]="lisTipoDocumento"
                                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                     formControlName="tipoDocumento"
                                    (onChange)="f.numeroDocumento.setValue('')"
                                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                    optionValue="value"
                                    optionLabel="label"
                        ></p-dropdown>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tipoDocumento.invalid">
                          {{ 'LBL_TIPODOCUMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label>* {{ 'LBL_NUMERODOCUMENTO' | translate }}</label>
                        <input type="text" pInputText id="idNumeroDocumento"
                               name="nomNumeroDocumento"
                               autocomplete="off"
                               formControlName="numeroDocumento"
                               maxlength="25"
                               document-type [listDocumentsType]="tiposDocumentos" [typeDocument]="f.tipoDocumento.value"
                               appTexto
                               [sinLetras]="true"
                               [sinCaracteres]="true"
                               [sinComa]="true"
                               [sinPunto]="true"
                               [sinEspacio]="true"
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tipoDocumento.invalid">
                          {{ 'LBL_NUMERODOCUMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid form-footer-buttons">
                    <div class="form-group col-12">
                      <div *ngIf="!consultando">
                        <button icon="fa fa-search" label="{{'BTN_BUSCAR' | translate }}"
                                type="submit"
                                pButton></button>
                      </div>
                      <div *ngIf="consultando">
                        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                        <span>{{'LBL_CONSULTANDO' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </form>
                <app-detalle-tercero *ngIf="tercero && tercero.idTercero" [third]="tercero" [view]="false"
                                     [edit]="false"
                                     [clasification]="false"></app-detalle-tercero>

                <div class="grid form-footer-buttons" *ngIf="tercero && tercero.idTercero">
                  <div class="form-group col-12">
                    <div *ngIf="!guardando">
                      <a (click)="regresar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-trash" label="{{'BTN_LIMPIAR' | translate }}"
                              type="button" (click)="limpiar()"
                              pButton></button>
                      <button icon="fa fa-plus" label="{{'BTN_SELECCIONAR' | translate }}"
                              type="button" (click)="seleccionar()"
                              pButton></button>
                    </div>
                    <div *ngIf="guardando">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </p-panel>
          </div>
        </div>
      </div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"
            *ngIf="menu.agregar && menu.editar"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"
            *ngIf="menu.agregar && menu.editar"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="cd.accept()"
            *ngIf="!menu.agregar || !menu.editar"></button>
  </ng-template>
</p-confirmDialog>
